export function getBrowser() {
    var u = navigator.userAgent;
    const chrome = u.match(/Chrome\/([\d.]+)/)||u.match(/CriOS\/([\d.]+)/);
    return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),  //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
        iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
        webview: sessionStorage.getItem('deviceOS'),

    };
}

export function isMobile() {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)
}

export function getDeviceSystem() {
  var isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
  var isM = isMobile()
  return isM ? (isIOS ? 'ios' : 'android') : 'pc'
}

export function debounce(fn, delay = 300) {
  let timer = null
  return function(...args) {
      if (timer != null){
          clearTimeout(timer)
          timer = null
      }
      timer = setTimeout(() => {
          fn.call(this, ...args)
      }, delay)
  }
}

export function closeBrowser() {
    const browserInfo = getBrowser()
    window.alert(JSON.stringify({
      action: 'close'
    }))
    // if (browserInfo.webview) {
    //     window.alert(JSON.stringify({
    //         action: 'close'
    //     }))
    // }else {
    //   window.location.href="about:blank";
    //   window.close();
    // }
}


 /**
   * 节流函数 一段时间内至少触发n次
   * @param func 
   * @param wait 
   * @param mustRun 
   * @returns 
   */
  export function throttle(func, wait, mustRun) {
    var timeout,
      startTime = new Date();
  
    return function() {
      var context = this,
        args = arguments,
        curTime = new Date();
  
      clearTimeout(timeout);
      // 如果达到了规定的触发时间间隔，触发 handler
      if(curTime - startTime >= mustRun){
        func.apply(context,args);
        startTime = curTime;
      // 没达到触发间隔，重新设定定时器
      }else{
        timeout = setTimeout(func, wait);
      }
    };
  };